var app = {
	header: {
		closeButton: "Cerrar",
		copyrightLabel: "Copyright",
		helpLabel: "Ayuda",
		legalNoticeLabel: "Aviso legal",
		logoutButton: "Cerrar sesión",
		menuLabel: "Menú",
		noUserDataLabel: "No hay datos de usuario disponibles",
		notificationsLabel: "Notificaciones",
		privacyPolicyLabel: "Política de privacidad",
		serviceAppLabel: "Service-App",
		settingsLabel: "Configuración",
		shopLabel: "Shop",
		smartFactorySuiteLabel: "Smart-Factory Suite",
		userLabel: "Perfil",
		userProfileLinkText: "Perfil de Usuario"
	}
};
var contentLoadingError = "No se puede cargar el contenido";
var dashboard = {
	cancel: {
		button: "Cancelar"
	},
	edit: {
		button: "Editar"
	},
	reset: {
		button: "Restablecer"
	},
	save: {
		button: "Guardar"
	},
	share: {
		button: "Compartir"
	}
};
var filter = {
	clear: "Borrar los filtros",
	clearAll: "Borrar todos los filtros"
};
var locationMap = {
	locationLink: {
		label: "Ve a la ubicación"
	}
};
var machineDiscontinuation = {
	linkText: "Saber más"
};
var notifications = {
	button: {
		loadMore: "Cargar más"
	},
	date: {
		lastMonth: "El mes pasado",
		lastWeek: "La semana pasada",
		older: "Anterior",
		thisMonth: "Este mes",
		thisWeek: "Esta semana",
		today: "Hoy",
		yesterday: "Ayer"
	},
	error: {
		general: "Actualmente no se pueden mostrar notificaciones. Vuelva a intentarlo más tarde.",
		unauthorized: "Inicia sesión para ver las notificaciones"
	},
	info: {
		activateSettings: "Para recibir notificaciones, actívalas en la configuración",
		noNotification: "Actualmente no hay mensajes para ti."
	},
	title: "Notificaciones"
};
var results = {
	counter: {
		label: "resultados"
	}
};
var scrollToTop = {
	label: "Volver arriba"
};
var slider = {
	nextButton: {
		label: "Siguiente diapositiva"
	},
	paginationBullet: {
		label: "Diapositiva"
	},
	prevButton: {
		label: "Diapositiva anterior"
	}
};
var sorting = {
	ascending: "Ascendente",
	descending: "Descendente"
};
var userAccount = {
	address: {
		label: "Dirección postal"
	},
	email: {
		label: "Correo electrónico"
	},
	language: {
		label: "Idioma",
		locale: "Configuración regional",
		select: "Seleccionar idioma",
		settings: "Configuración de idioma"
	},
	loggedOut: {
		message: "No has iniciado sesión"
	},
	login: {
		button: "Iniciar sesión"
	},
	name: {
		label: "Nombre"
	},
	phone: {
		label: "Teléfono"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Filtrar máquinas",
			label: "Máquinas",
			option: {
				all: "Todas las máquinas"
			},
			select: "Seleccionar máquina"
		},
		period: {
			label: "Período",
			option: {
				currentMonth: "Este mes",
				currentWeek: "Esta semana",
				lastMonth: "Último mes",
				lastWeek: "La semana pasada",
				today: "Hoy",
				yesterday: "Ayer"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Mis widgets"
	},
	noDescriptionAvailable: "No hay descripción disponible.",
	widget: {
		SampleMyMachines: {
			title: "Mis Máquinas"
		},
		SampleMyServiceCalls: {
			title: "Llamadas de servicio"
		},
		SampleMyTrackingList: {
			title: "Lista de seguimiento"
		},
		SampleMyUserAccount: {
			title: "Mi perfil"
		},
		SampleOperationalStatesChart: {
			title: "Estados operativos"
		},
		SampleWidgetFilter: {
			title: "Configuración de filtro"
		},
		SampleWorkloadBalanceChart: {
			title: "Saldo de la carga de trabajo"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	filter: filter,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, filter, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
